import React from "react";
import { useState } from "react";
import { is_franchise_admin, is_franchise_manager, is_franchise_staff, is_superuser } from "../Functionalities/Config";

export default function ReportStatusModalComponent({ heading, confirmStatus }) {
  // void 0


  const [data, setData] = useState({
    // mode_of_payment: "CASH",
    keyword:(is_superuser)?"FRANCHISE_TRANSACTION":"ADMIN_TRANSACTION",
    status: "",
  })

  return (
    <div className="modal fade" id="ReportStatusModal">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{heading}</h5>
            <button type="button" className="close" data-dismiss="modal">
              <span>×</span>
            </button>
          </div>

          <div className="modal-body">
            <form className="comment-form">
              <div className="row">

                Status<br />
                <select
                  value={data.status}
                  className="form-control form-control-lg default-select "
                  onChange={(e) => { setData({ ...data, status: (e.target.value) }) }}

                >
                  <option value={""}>Select type</option>
                  <option value={"PENDING"} > Pending</option>
                  <option value={"PROCESSING"} >Processing</option>
                  <option value={"COMPLETED"}  > Completed</option>
                  <option value={"DECLINED"}  > Cancelled</option>
                </select>

                <br />
                {/* Payment type<br />
                <select
                  value={data.mode_of_payment}
                  className="form-control form-control-lg default-select "

                  onChange={(e) => { setData({ ...data, mode_of_payment: (e.target.value) }) }}


                >
                  <option value={"CASH"} > CASH</option>
                  <option value={"ONLINE"} >ONLINE</option>
                </select>
                <br /> */}
                {/* 

FRANCHISE_TRANSACTION - super admin to franchise

ADMIN_TRANSACTION - franchise to admin
BRANCH_TRANSACTION - franchise to branch 

*/}

                Payment type<br />
                <select
                disabled={is_superuser?true:false}
                  value={data.keyword}
                  className="form-control form-control-lg default-select "
                  onChange={(e) => { setData({ ...data, keyword: (e.target.value) }) }}
                >
                  {(is_superuser)&&<option value={"FRANCHISE_TRANSACTION"} >Submit Amount to Franchise</option>}

                  {(is_franchise_admin || is_franchise_manager || is_franchise_staff)&&<option value={"ADMIN_TRANSACTION"} >Submit Amount to Foodoor</option>}
                  {(is_franchise_admin || is_franchise_manager || is_franchise_staff)&&<option value={"BRANCH_TRANSACTION"} >Submit Amount to Restaurant</option>}
                </select>

              </div>
              <div className="col-lg-12 pt-3">
                <div className="form-group mb-0 text-center">
                  <button style={{ marginRight: 10 }} data-dismiss="modal" className="submit btn btn-primary" name="submit"
                  // onClick={clearSelectedColumns} 
                  >
                    Cancel
                  </button>
                  <button style={{ marginRight: 10 }} data-dismiss="modal" type="submit" id="tests" className="submit btn btn-primary" name="submit"
                    onClick={() => { confirmStatus(data) }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
